import { useMemo, useState } from "react";

// porp-types is a library for typechecking of props
import PropTypes from "prop-types";

// react-chartjs-2 components
import { Bar } from "react-chartjs-2";

// @mui material components
import Card from "@mui/material/Card";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// VerticalBarChart configurations
import configs from "examples/Charts/BarCharts/VerticalBarChart/configs";

// Soft UI Dashboard React base styles
import colors from "assets/theme/base/colors";
import ApnaSelect from "components/ApnaSelect";

function VerticalBarChart({ title, description, height, chart, option, handleFilterChange, selectedFilter, handleOnClickBarChart }) {

  const chartDatasets = chart.datasets
    ? chart.datasets.map((dataset) => ({
      ...dataset,
      weight: 5,
      borderWidth: 0,
      borderRadius: 4,
      backgroundColor: colors[dataset.color]
        ? colors[dataset.color || "dark"].main
        : colors.dark.main,
      fill: false,
      maxBarThickness: 35,
    }))
    : [];

  const { data, options } = configs(chart.labels || [], chartDatasets);


  const renderChart = (
    <SoftBox p={2} >

      <SoftBox display="flex" justifyContent="space-between" alignItems="center">
        <SoftBox>
          {title || description ? (
            <SoftBox px={description ? 1 : 0} pt={description ? 1 : 0}>
              {title && (
                <SoftBox mb={1}>
                  <SoftTypography variant="h6">{title}</SoftTypography>
                </SoftBox>
              )}
              <SoftBox mb={2}>
                <SoftTypography component="div" variant="button" fontWeight="regular" color="text">
                  {description}
                </SoftTypography>
              </SoftBox>
            </SoftBox>
          ) : null}
        </SoftBox>

        <SoftBox>
          <ApnaSelect
            value={selectedFilter}
            options={option}
            onChange={handleFilterChange}
          />
        </SoftBox>
      </SoftBox>



      {useMemo(
        () => (
          <SoftBox height={height}>
            <Bar data={data} options={options}
              getElementAtEvent={(element) => (element&&handleOnClickBarChart(element[0]?.index))}
            />
          </SoftBox>
        ),
        [chart, height]
      )}
    </SoftBox>
  );

  return title || description ? <Card    className="glassmorphism-card">{renderChart}</Card> : renderChart;
}

// Setting default values for the props of VerticalBarChart
VerticalBarChart.defaultProps = {
  title: "",
  description: "",
  height: "19.125rem",
};

// Typechecking props for the VerticalBarChart
VerticalBarChart.propTypes = {
  title: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  chart: PropTypes.objectOf(PropTypes.array).isRequired,
};

export default VerticalBarChart;
